import React, { useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import { useParams } from "react-router-dom";
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import MenuCaracterizacion from './Componentes/MenuCaracterizacion';
import DatosCabezaFamilia from './DatosCabezaFamilia';
import { useAuth } from '../../Auth/AuthContext';

export default function VidaLibertad(){
    const { token } = useAuth();
    const { idCabezaFamilia } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    useEffect(() => {
        const fetchData = async () => {
            let url = '/caracterizacion/crearformulariovidalibertad';
            let obj = {idCabezaFamilia: idCabezaFamilia}
            try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            } catch (error) {
            console.error('Error fetching data:', error);
            } finally {
            setCargando(false);
            }
        };

        fetchData();
    }, []);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const {register, handleSubmit, control, setValue, reset, watch, getValues, formState: { errors }} = useForm();
    const onSubmit = async (data) => {
        setCargando(true);
        let url = (data.id === 0)?'/caracterizacion/vidalibertad/guardar':'/caracterizacion/vidalibertad/actualizar';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar vida y libertad', 'Registro guardado con exito');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar vida y libertad', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar vida y libertad', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Vida y libertad</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Vida y libertad</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}></MenuCaracterizacion>
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <div className='card'>
                            <div className="card-body">
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/><input hidden {...register('id')}/>
                                
                                
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-info">Guardar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                            didClose={() => {
                                setSwalProps({})
                            }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}